import { Metric } from "../Metric"
import ObjectUtil from "../../util/ObjectUtil"
import CollectionUtil from "../../util/CollectionUtil"
import { Transport, TransportRequest } from "../../transport/Transport"

export abstract class MonitoringMetricDispatcher {
  dispatch(payload: Metric[], sync: boolean): Promise<void> {
    const batch = this.batch(payload)
    return this.doDispatch(batch, sync)
  }

  protected abstract doDispatch(payload: MetricBatchDto, sync: boolean): Promise<void>

  private batch(metrics: Metric[]): MetricBatchDto {
    return {
      metrics: metrics.map((metric) => ({
        name: metric.id.name,
        type: metric.id.type,
        tags: metric.id.tags,
        measurements: ObjectUtil.fromMap(
          CollectionUtil.associate(metric.measure(), (measurement) => [measurement.field, measurement.value])
        )
      }))
    }
  }
}

interface MetricDto {
  name: string
  type: string
  tags: Record<string, string>
  measurements: Record<string, number>
}

interface MetricBatchDto {
  metrics: MetricDto[]
}

export class BrowserMonitoringMetricDispatcher extends MonitoringMetricDispatcher {
  constructor(
    private readonly url: string,
    private readonly transport: Transport,
    private readonly synchronousTransport: Transport
  ) {
    super()
  }

  protected async doDispatch(payload: MetricBatchDto, sync: boolean): Promise<void> {
    const request = TransportRequest.builder()
      .method("POST")
      .url(this.url)
      .body(JSON.stringify(payload))
      .addHeader("Content-Type", "text/plain;charset=UTF-8") // text/plain body to avoid CORS preflight
      .build()
    const transport = sync ? this.synchronousTransport : this.transport
    await transport.send(request)
  }
}

export class NodeMonitoringMetricDispatcher extends MonitoringMetricDispatcher {
  constructor(private readonly url: string, private readonly transport: Transport) {
    super()
  }

  protected async doDispatch(payload: MetricBatchDto, sync: boolean): Promise<void> {
    const request = TransportRequest.builder()
      .method("POST")
      .url(this.url)
      .body(JSON.stringify(payload))
      .addHeader("Content-Type", "application/json")
      .build()
    await this.transport.send(request)
  }
}
